import React, { useEffect, useState, useRef } from 'react';
import { Bold } from 'components/Texts';
import { Grid } from '@material-ui/core';

import FinancialChatInput from './FinancialChatInput';
import FinancialChatMessage from './FinancialChatMessage';

export const getFinancialValue = (type, value, activeValue) => {
  if (typeof value === 'object' && value.textValue) {
    return value.textValue;
  }
  if (type === 'bool') {
    if (value) {
      return 'Sí';
    }
    return 'No';
  }
  if (type === 'list') {
    const { values } = activeValue;
    if (Array.isArray(values)) {
      return value;
    }
    return activeValue.values[value];
  }
  return value;
};

export default function FinancialChatDelayer({ data, update, addMessage }) {
  const lastRef = useRef();
  const [show, setShow] = useState(0);
  const [tempValue, setTempValue] = useState();
  const [tempText, setTempText] = useState();
  const [lastData, setLastData] = useState(data);
  const [counter, setCounter] = useState(0);
  const next = () => {
    const time = setTimeout(() => {
      setShow((currShow) => {
        const newValue = currShow + 1;
        if ((tempText && newValue < tempText?.length + 1) || newValue < data?.message?.length) {
          next();
        }
        return newValue;
      });
    }, Math.random() * 5000);
    return () => clearTimeout(time);
  };
  const setTemporalText = (text) => {
    setShow(0);
    next();
    setTempText(text);
  };
  const onConfirm = (confirm, newValue) => {
    addMessage({
      received: true,
      messages: data?.message,
      key: `new-message-${counter}`,
    });
    if (confirm) {
      update(newValue);
      setTemporalText();
    } else {
      setTempValue();
      if (data.question) {
        setTemporalText([
          'Ingresa tu información correcta a continuación',
          data.question,
        ]);
      } else {
        setTemporalText([
          'Ingresa tu información correcta a continuación',
          ...data.message,
        ]);
      }
    }
    addMessage({
      key: `new-message-${counter + 1}`,
      messages: [getFinancialValue(data.type, newValue, data)],
    });
    setCounter((v) => v + 2);
  };
  useEffect(() => {
    lastRef?.current?.scrollIntoView();
  }, [show]);
  useEffect(() => {
    if (data) {
      if (!lastData || (data.field !== lastData.field)) {
        setShow(0);
        next();
        setLastData(data);
      }
      if (data.value !== undefined && data.value !== tempValue) {
        setTempValue(data.value);
        onConfirm(true, data.value);
      } else {
        setTempValue();
      }
    }
  }, [data]);
  return (
    <Grid container>
      {tempText
        ? (
          <FinancialChatMessage
            noMinWidth={show < tempText?.length}
            messages={
              show < tempText?.length
                ? [...tempText?.slice(0, show), <Bold>...</Bold>]
                : tempText
            }
            received
          />
        )
        : (
          <FinancialChatMessage
            noMinWidth={(data && data.noMinWidth) || (show < data?.message?.length)}
            messages={
              show < data?.message?.length
                ? [...data?.message?.slice(0, show), <Bold>...</Bold>]
                : data?.message
            }
            received
          />
        )}
      {tempValue === undefined
        && ((tempText && tempText?.length <= show)
        || (!tempText && data?.message?.length <= show))
        && (
        <FinancialChatInput update={(newValue) => onConfirm(true, newValue)} {...data} />
        )}
      <div style={{ width: '100%' }} ref={lastRef} />
    </Grid>
  );
}
